import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Pill, Clock, Filter } from 'lucide-react';
import { MedicationCatalogTab, MedicationScheduleTab, PrescriptionsTab } from '../components/medications';

export const MedicationsPage = () => {
  const { t } = useTranslation('medications');

  return (
    <div className="p-2 space-y-6" data-testid="medications-page" style={{ fontFamily: "'Inter Tight', system-ui, sans-serif" }}>
      {/* Header */}
      <div>
        <h1 className="text-2xl font-semibold text-[var(--ink)]" style={{ letterSpacing: '-0.02em' }}>{t('title')}</h1>
        <p className="text-[var(--ink-3)] mt-1 text-sm">{t('subtitle')}</p>
      </div>

      {/* Tabs */}
      <Tabs defaultValue="schedule" className="w-full">
        <TabsList className="grid w-full grid-cols-3 lg:w-auto lg:inline-flex mb-6">
          <TabsTrigger value="schedule" data-testid="schedule-tab">
            <Clock className="h-4 w-4" />
            {t('tabs.schedule')}
          </TabsTrigger>
          <TabsTrigger value="prescriptions" data-testid="prescriptions-tab">
            <Pill className="h-4 w-4" />
            {t('tabs.prescriptions')}
          </TabsTrigger>
          <TabsTrigger value="catalog" data-testid="catalog-tab">
            <Filter className="h-4 w-4" />
            {t('tabs.catalog')}
          </TabsTrigger>
        </TabsList>

        <TabsContent value="schedule">
          <Card className="bg-white shadow-[var(--shadow-sm)] border-0 rounded-xl">
            <CardHeader>
              <CardTitle className="text-lg font-semibold text-[var(--ink)]">{t('schedule.title')}</CardTitle>
              <CardDescription className="text-[var(--ink-3)]">{t('schedule.subtitle')}</CardDescription>
            </CardHeader>
            <CardContent>
              <MedicationScheduleTab />
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="prescriptions">
          <Card className="bg-white shadow-[var(--shadow-sm)] border-0 rounded-xl">
            <CardHeader>
              <CardTitle className="text-lg font-semibold text-[var(--ink)]">{t('prescriptions.title')}</CardTitle>
              <CardDescription className="text-[var(--ink-3)]">{t('prescriptions.subtitle')}</CardDescription>
            </CardHeader>
            <CardContent>
              <PrescriptionsTab />
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="catalog">
          <Card className="bg-white shadow-[var(--shadow-sm)] border-0 rounded-xl">
            <CardHeader>
              <CardTitle className="text-lg font-semibold text-[var(--ink)]">{t('catalog.title')}</CardTitle>
              <CardDescription className="text-[var(--ink-3)]">{t('catalog.subtitle')}</CardDescription>
            </CardHeader>
            <CardContent>
              <MedicationCatalogTab />
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default MedicationsPage;
